export enum PaginationType {
	DEFAULT = "default",
    COMPACT = "compact"
}
